import { fetchLatestNotice, sendNotice } from '../api/serveraccess'

export default function (){
  
  const getLatestNotice = async( callback ) =>{
    try{
      var account = await fetchLatestNotice()
      callback("success", account)
    }catch(e){
      callback(e)
    }
  }
  
  const registNotice = async( regNotice, callback  ) => {
    try{
      var result = await sendNotice( regNotice )
      callback("success", result )
    }catch(e){
      callback(e)
    }
  }
  


  
 
  //当該ライブラリが提供する変数、メソッドを宣言
  return{
    getLatestNotice,
    registNotice
  }
}